<script>
    export let password;
    
    $: minimumLength = password?.length >= 6;
</script>

<div>
    <span class="requirement {minimumLength?"fullfilled":""}"><i class="icon-ok-circled"></i>mindestens 6 Zeichen</span>
</div>

<style>
    div {
        margin: 1rem 0;
    }

    .requirement {
        color: grey;
    }

    .fullfilled>i {
        color: green;
    }

    i::before {
        margin: 0;
        margin-inline-end: 0.3rem;
    }
</style>